
import Vue from 'vue';
import ABaseComponent from 'Components/Base/ABaseComponent';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Client, IPorter, IOrderLine, IInvoiceViewModel } from 'Api/CoreApi';
import { CartClient, CopyItemsFromExistingOrderArgs } from "Api/DynamicwebApi"
//import UserInformationComponent from "Components/Base/UserInformationComponent";
import PorterBudgetStore from "Store/porterBudget/porterBudget";
import { State } from 'vuex-class';
import { CartState } from 'Store/types';
import ApiProvider from 'Api/ApiProvider';

@Component({})
export class InvoiceDetailsComponent extends ABaseComponent {
    @Prop()
    linkId: string;

    @Prop()
    public isPorter: boolean;

    invoice: IInvoiceViewModel = {};
    canApprove: boolean = false;

    get porter() {
        return PorterBudgetStore.state.porter;
    }

    async created() {
        try {
            let client = ApiProvider.getApiClient();
            if (this.isPorter) {
                await PorterBudgetStore.dispatchFetchPorter();
            }
            let invoiceModel = await client.getInvoice(this.linkId);
            this.invoice = invoiceModel.invoice;
            this.canApprove = invoiceModel.canApprove;
            this.setLoaded();
        } catch (e) {
            this.setError(e);
        }
    }

    get showBudgetPoint() {
        if (this.porter) {
            return this.porter.showBudgetPoints;
        }
        else
            return false;
    }

    get totalBudgetPoints() {
        return this.invoice.invoice.orderLines.reduce((total, item) => {
            return total + (item.extraInfo.BudgetPoints * item.quantity)
        }, 0)
    }

    get totalBudgetPrice() {
        return this.invoice.invoice.orderLines.reduce((total, item) => {
            return total + (item.extraInfo.BudgetPrice * item.quantity)
        }, 0)
    }

    get porterLines() {
        let result: { [contactNo: string]: IOrderLine[] } = {};
        if (!this.invoice) return result;

        this.invoice.invoice.orderLines.forEach(item => {
            let key = item.extraInfo['ContactNo'] || '';
            let orderlines = result[key];
            if (!orderlines) {
                result[key] = orderlines = [];
            }
            orderlines.push(item);
        })
        return result;
    }
}
Vue.component('invoice-details', InvoiceDetailsComponent);